const sizes = {
  sm: { box: 32, r: 7, text: 'text-base' },
  md: { box: 40, r: 9, text: 'text-lg' },
  lg: { box: 56, r: 12, text: 'text-2xl' },
};

export default function TrackFlowLogo({ size = 'sm', showText = false, textDark = false, className = '' }) {
  const { box, r } = sizes[size] || sizes.sm;
  const textClass = sizes[size]?.text || 'text-base';

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg
        width={box}
        height={box}
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
      >
        <defs>
          <linearGradient id="tf-grad" x1="4" y1="38" x2="36" y2="10" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#22c55e" />
            <stop offset="50%" stopColor="#06b6d4" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
        </defs>

        {/* Background rounded rect */}
        <rect width="56" height="56" rx={r} fill="#0d1117" />

        {/* Flow path: loop at bottom-left, sweep up-right into arrow */}
        <path
          d="M14 36 C14 30 10 24 16 20 C22 16 28 22 28 28 C28 34 34 38 40 34 C46 30 44 22 38 20"
          stroke="url(#tf-grad)"
          strokeWidth="3.5"
          strokeLinecap="round"
          fill="none"
        />
        {/* Arrow head pointing right */}
        <path
          d="M34 16 L40 20 L34 24"
          stroke="url(#tf-grad)"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />

        {/* Play circle — top right */}
        <circle cx="42" cy="16" r="7" fill="#2563eb" />
        <polygon points="40,13.5 40,18.5 45,16" fill="white" />
      </svg>

      {showText && (
        <span className={`font-bold tracking-tight ${textDark ? 'text-gray-900' : 'text-white'} ${textClass}`}>
          {import.meta.env.VITE_APP_NAME || 'TrackFlow'}
        </span>
      )}
    </div>
  );
}
